import script from "./MonthlyActivityChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyActivityChart.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyActivityChart.vue?vue&type=style&index=0&id=ace2cefc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace2cefc"]])

export default __exports__